import { webOrder as initialState } from '../initialState.tsx';
import {
    REQUEST_WEBORDER_UPDATE,
    RECEIVE_WEBORDER_UPDATE,
    ERROR_WEBORDER_UPDATE,
    REQUEST_BROKER_LENDERS,
    RECEIVE_BROKER_LENDERS,
    ERROR_BROKER_LENDERS,
    REQUEST_BROKER_REPORT_TYPES,
    RECEIVE_BROKER_REPORT_TYPES,
    ERROR_BROKER_REPORT_TYPES,
    REQUEST_APPOINTMENT_HOLIDAYS,
    RECEIVE_APPOINTMENT_HOLIDAYS,
    ERROR_APPOINTMENT_HOLIDAYS,
    RESET_WEB_ORDER,

    REQUEST_CHECKOUT_GET, RECEIVE_CHECKOUT_GET, ERROR_CHECKOUT_GET,
    REQUEST_CHECKOUT_SAVE, RECEIVE_CHECKOUT_SAVE, ERROR_CHECKOUT_SAVE,
    REQUEST_CHECKOUT_CANCEL, RECEIVE_CHECKOUT_CANCEL, ERROR_CHECKOUT_CANCEL,
    REQUEST_BROKER_BILLING_PREVIEW, RECEIVE_BROKER_BILLING_PREVIEW, ERROR_BROKER_BILLING_PREVIEW,
} from 'typeConstants';

const webOrder = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_WEBORDER_UPDATE:
            return {
                ...state,
                confirmationNumber: null
            };
        case REQUEST_BROKER_LENDERS:
            return {
                ...state,
                lenders: {
                    ...state.lenders,
                    isFething: true
                }
            };
        case REQUEST_BROKER_REPORT_TYPES:
            return {
                ...state,
                reportType: {
                    ...state.reportType,
                    isFething: true
                }
            };
        case REQUEST_APPOINTMENT_HOLIDAYS:
            return {
                ...state,
                appointmentHolidays: {
                    ...state.appointmentHolidays,
                    isFething: true
                }
            };
        case RECEIVE_WEBORDER_UPDATE:
            return {
                ...state,
                confirmationNumber: action.payload.error ? null : "" + action.payload.webOrderID,
                lastLoanNumber: action.payload.error ? null : "" + action.payload.loanNumber
            };
        case RECEIVE_BROKER_LENDERS:
            return {
                ...state,
                lenders: {
                    ...state.lenders,
                    isFething: false,
                    lenderList: action.payload
                }
            };
        case RECEIVE_BROKER_REPORT_TYPES:
            return {
                ...state,
                reportType: {
                    ...state.reportType,
                    isFething: false,
                    availReportTypes: action.payload
                }
            };
        case RECEIVE_APPOINTMENT_HOLIDAYS:
            return {
                ...state,
                appointmentHolidays: {
                    ...state.appointmentHolidays,
                    isFething: false,
                    holidayList: action.payload
                }
            };
        case ERROR_WEBORDER_UPDATE:
            return {
                ...state
            };
        case ERROR_BROKER_LENDERS:
            return {
                ...state,
                lenders: {
                    ...state.lenders,
                    isFething: false
                }
            };
        case ERROR_BROKER_REPORT_TYPES:
            return {
                ...state,
                reportType: {
                    ...state.reportType,
                    isFething: false
                }
            };
        case ERROR_APPOINTMENT_HOLIDAYS:
            return {
                ...state,
                appointmentHolidays: {
                    ...state.appointmentHolidays,
                    isFething: false
                }
            };
        case RESET_WEB_ORDER:
            // preserve the last Loan Number and WebOrderID
            return {
                ...initialState,
                lastLoanNumber: state.lastLoanNumber
            };

        case REQUEST_CHECKOUT_GET: return { ...state, fetchingCheckout: true };
        case RECEIVE_CHECKOUT_GET: return { ...state, fetchingCheckout: false, checkout: action.payload };
        case ERROR_CHECKOUT_GET: return { ...state, fetchingCheckout: false, checkout: { result: { error: true, errorMessages: "Not Found" } } };

        case REQUEST_CHECKOUT_SAVE: return { ...state, savingCheckout: true };
        case RECEIVE_CHECKOUT_SAVE: return {
            ...state,
            savingCheckout: false,
            confirmationNumber: action.payload.error ? null : "" + action.payload.loanNumber,
            lastLoanNumber: action.payload.error ? null : "" + action.payload.loanNumber
        };
        case ERROR_CHECKOUT_SAVE: return { ...state, savingCheckout: false };

        case REQUEST_CHECKOUT_CANCEL: return { ...state, cancelingCheckout: true };
        case RECEIVE_CHECKOUT_CANCEL: return { ...state, cancelingCheckout: false, checkout: action.payload };
        case ERROR_CHECKOUT_CANCEL: return { ...state, cancelingCheckout: false };

        case REQUEST_BROKER_BILLING_PREVIEW: return { ...state, billingAmount: 0.0 };
        case RECEIVE_BROKER_BILLING_PREVIEW: return { ...state, billingAmount: action.payload };
        case ERROR_BROKER_BILLING_PREVIEW: return { ...state, billingAmount: null };

        default:
            return state;
    }
};

export default webOrder;
